import { render, staticRenderFns } from "./settings-history.modal.vue?vue&type=template&id=34c89d5f&"
import script from "./settings-history.modal.vue?vue&type=script&lang=js&"
export * from "./settings-history.modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports